import React from "react";
import TopNav from "../../bars/TopNav";
import Footer from "../../bars/Footer";

function Privacy() {
  const definitions = [
    {
      head: "Service",
      content:
        "‍Service is the https://inaipi.ai/ website operated by Inaipi Private Limited",
    },
    {
      head: "‍Personal Data",
      content:
        "‍Personal Data means data about a living individual who can be identified from those data (or from those and other information either in our possession or likely to come into our possession).",
    },
    {
      head: "‍Usage Data",
      content:
        "‍Usage Data is data collected automatically either generated by the use of the Service or from the Service infrastructure itself (for example, the duration of a page visit).",
    },
    {
      head: "Cookies",
      content:
        "‍‍Cookies are small files stored on your device (computer or mobile device).",
    },
    {
      head: "‍Data Controller",
      content:
        "‍Data Controller means the natural or legal person who (either alone or jointly or in common with other persons) determines the purposes for which and the manner in which any personal information are, or are to be, processed.For the purpose of this Privacy Policy, we are a Data Controller of your Personal Data.",
    },
    {
      head: "‍Data Processors (or Service Providers)",
      content:
        "‍Data Processor (or Service Provider) means any natural or legal person who processes the data on behalf of the Data Controller.We may use the services of various Service Providers in order to process your data more effectively.",
    },
    {
      head: "‍‍Data Subject (or User)",
      content:
        "‍‍Data Subject is any living individual who is using our Service and is the subject of Personal Data.",
    },
  ];
  return (
    <div>
      <TopNav />

      <div className="top_section w-full mt-24 mb-10">
        <h2>Privacy Policy</h2>
        <p className=""><br/>
          Effective date: July 01, 2023 <br/><br/>Inaipi Private Limited ("us", "we", or "our")
          operates the https://inaipi.ai/ website (hereinafter referred
          to as the "Service").<br/> <br/>This page informs you of our policies regarding
          the collection, use and disclosure of personal data when you use our
          Service and the choices you have associated with that data.<br/><br/> We use
          your data to provide and improve the Service. By using the Service,
          you agree to the collection and use of information in accordance with
          this policy. Unless otherwise defined in this Privacy Policy, the
          terms used in this Privacy Policy have the same meanings as in our
          Terms and Conditions, accessible from https://inaipi.ai/
        </p>

        <h3 className="mt-5">Definitions</h3>
        <p className="">
          {definitions.map((item, index) => (
            <div key={index}>
             <br/> <b>{item.head}</b><br/> {item.content}
            </div>
          ))}
          <p></p>
        </p>
        <h3 className="mt-5">Information Collection & Use</h3>
        <p className="">
          We collect several different types of information for various purposes
          to provide and improve our Service to you.
        </p>

        <h3 className="mt-5">Type of data collected</h3>
        <br />
        <b>Personal Data</b>
        <br />
        <p className="">
          While using our Service, we may ask you to provide us with certain
          personally identifiable information that can be used to contact or
          identify you ("Personal Data"). Personally identifiable information
          may include, but is not limited to: <br /><br />
          Email address
          <br />
          First name and last name
          <br />
          Phone number
          <br />
          Address, State, Province, ZIP/Postal code, City
          <br />
          Cookies and Usage Data
          <br /><br />
          We may use your Personal Data to contact you with newsletters,
          marketing or promotional materials and other information that may be
          of interest to you. You may opt out of receiving any, or all, of these
          communications from us by following the unsubscribe link or
          instructions provided in any email we send or by contacting us.
        </p>

        <h3 className="mt-5">Usage Data</h3>
        <p>
          We may also collect information on how the Service is accessed and
          used ("Usage Data"). This Usage Data may include information such as
          your computer's Internet Protocol address (e.g. IP address), browser
          type, browser version, the pages of our Service that you visit, the
          time and date of your visit, the time spent on those pages, unique
          device identifiers and other diagnostic data.
        </p>
        <h3 className="mt-5">Tracking & Cookies Data</h3>
        <p>
          We use cookies and similar tracking technologies to track the activity
          on our Service and we hold certain information.<br /><br /> Cookies are files with
          a small amount of data which may include an anonymous unique
          identifier. Cookies are sent to your browser from a website and stored
          on your device. Other tracking technologies are also used such as
          beacons, tags and scripts to collect and track information and to
          improve and analyse our Service.<br /><br /> You can instruct your browser to
          refuse all cookies or to indicate when a cookie is being sent.
          However, if you do not accept cookies, you may not be able to use some
          portions of our Service.<br /><br /> Examples of Cookies we use:
          <br />
          <b>Session Cookies</b>. We use Session Cookies to operate our Service.
          <br />‍<b>Preference Cookies.</b> We use Preference Cookies to
          remember your preferences and various settings.
          <br />‍<b>Security Cookies.</b> We use Security Cookies for security
          purposes.
          <br />
        </p>

        <h3 className="mt-5">Use of Data</h3>
        <p>
          Inaipi Private Limited uses the collected data for various purposes:<br /> <br /> To
          provide and maintain our Service <br />To notify you about changes to our
          Service <br />To allow you to participate in interactive features of our
          Service when you choose to do so To provide customer support <br />To gather
          analysis or valuable information so that we can improve our Service<br /> To
          monitor the usage of our Service To detect, prevent and address
          technical issues <br />To provide you with news, special offers and general
          information about other goods, services and events which we offer that
          are similar to those that you have already purchased or enquired about
          unless you have opted not to receive such information
        </p>
        <h3 className="mt-5">
          Legal Basis for Processing Personal Data under General Data Protection
          Regulation (GDPR)
        </h3><br/>
        <p>
          If you are from the European Economic Area (EEA), Inaipi Private Limited
          legal basis for collecting and using the personal information
          described in this Privacy Policy depends on the Personal Data we
          collect and the specific context in which we collect it.<br/><br/> Inaipi Private Limited may process your Personal Data because:<br/><br/> We need to perform a
          contract with you<br/> You have given us permission to do so<br/> The processing
          is in our legitimate interests and it is not overridden by your rights<br/>
          For payment processing purposes To comply with the law
        </p>
        <h3 className="mt-5">Retention of Data</h3>
        <p>
         Inaipi Private Limited will retain your Personal Data only for as long as is
          necessary for the purposes set out in this Privacy Policy. We will
          retain and use your Personal Data to the extent necessary to comply
          with our legal obligations (for example, if we are required to retain
          your data to comply with applicable laws), resolve disputes and
          enforce our legal agreements and policies. <br/><br/>Inaipi Private Limited will also
          retain Usage Data for internal analysis purposes. Usage Data is
          generally retained for a shorter period of time, except when this data
          is used to strengthen the security or to improve the functionality of
          our Service, or we are legally obligated to retain this data for
          longer periods.
        </p>
        <h3 className="mt-5">Transfer of Data</h3>
        <p>
          Your information, including Personal Data, may be transferred to — and
          maintained on — computers located outside of your state, province,
          country or other governmental jurisdiction where the data protection
          laws may differ from those of your jurisdiction.<br/><br/> If you are located
          outside India and choose to provide information to us, please
          note that we transfer the data, including Personal Data, to India and process it there.<br/><br/> Your consent to this Privacy Policy
          followed by your submission of such information represents your
          agreement to that transfer. <br/><br/>Inaipi Private Limited will take all the steps
          reasonably necessary to ensure that your data is treated securely and
          in accordance with this Privacy Policy and no transfer of your
          Personal Data will take place to an organisation or a country unless
          there are adequate controls in place including the security of your
          data and other personal information.
        </p>
        <h3 className="mt-5">Disclosure of Data</h3><br/>
        <h4>Legal Requirements</h4><br/>
         
        <p>
          Inaipi Private Limited may disclose your Personal Data in the good faith
          belief that such action is necessary to<br/><br/> To comply with a legal
          obligation
          <br />
          To protect and defend the rights or property of Inaipi Private Limited
          <br />
          To prevent or investigate possible wrongdoing in connection with the
          Service
          <br />
          To protect the personal safety of users of the Service or the public
          <br />
          To protect against legal liability
        </p>

        <h4 className="mt-5">Security of Data</h4> 
        <p>
          The security of your data is important to us but remember that no
          method of transmission over the Internet or method of electronic
          storage is 100% secure. While we strive to use commercially acceptable
          means to protect your Personal Data, we cannot guarantee its absolute
          security.
        </p>
        <br/>
        <h4>
          Our Policy on "Do Not Track" Signals under Indian Data Protection Regulations
        </h4> 
        <p>
          We do not support Do Not Track ("DNT"). Do Not Track is a preference
          you can set in your web browser to inform websites that you do not
          want to be tracked. <br/><br/>You can enable or disable Do Not Track by visiting
          the Preferences or Settings page of your web browser.
        </p><br/>
        <h4>
          Your Data Protection Rights under the General Data Protection
          Regulation (GDPR)
        </h4>
        <p>
          If you are a resident of the European Economic Area (EEA), you have
          certain data protection rights. Inaipi Private Limited aims to take
          reasonable steps to allow you to correct, amend, delete or limit the
          use of your Personal Data. <br/><br/>If you wish to be informed about what
          Personal Data we hold about you and if you want it to be removed from
          our systems, please contact us.<br/><br/> In certain circumstances, you have the
          following data protection rights:
        </p><br/>
      
        <p>
         <b>‍The right to access, update or delete the information we have on you.</b> 
          Whenever made possible, you can access, update or request deletion of
          your Personal Data directly within your account settings section. If
          you are unable to perform these actions yourself, please contact us to
          assist you.<br/><b> ‍The right of rectification.</b> You have the right to have
          your information rectified if that information is inaccurate or
          incomplete.<br/><b> ‍The right to object.</b> You have the right to object to our
          processing of your Personal Data.
          <br />
          ‍<b>The right of restriction.</b> You have the right to request that we
          restrict the processing of your personal information.
          <br />
         <b> ‍The right to data portability.</b> You have the right to be provided with
          a copy of the information we have on you in a structured,
          machine-readable and commonly used format.
          <br />
         <b> ‍The right to withdraw consent. </b>You also have the right to withdraw
          your consent at any time where Inaipi Private Limited relied on your consent
          to process your personal information.
          <br /><br />
          Please note that we may ask you to verify your identity before
          responding to such requests.<br /><br /> You have the right to complain to a Data
          Protection Authority about our collection and use of your Personal
          Data. For more information, please contact your local data protection
          authority in the European Economic Area (EEA).
        </p>

        <h3 className="mt-5">Service Providers</h3>
        <p>
          We may employ third party companies and individuals to facilitate our
          Service ("Service Providers"), provide the Service on our behalf,
          perform Service-related services or assist us in analysing how our
          Service is used. <br/> <br/>These third parties have access to your Personal Data
          only to perform these tasks on our behalf and are obligated not to
          disclose or use it for any other purpose.
        </p>
        <h3 className="mt-5">Payments</h3>
        <p>
          We may provide paid products and/or services within the Service. In
          that case, we use third-party services for payment processing (e.g.
          payment processors).<br/><br/> We will not store or collect your payment card
          details. That information is provided directly to our third-party
          payment processors whose use of your personal information is governed
          by their Privacy Policy. These payment processors adhere to the
          standards set by PCI-DSS as managed by the PCI Security Standards
          Council, which is a joint effort of brands like Visa, MasterCard. PCI-DSS requirements help ensure the
          secure handling of payment information.  </p>

        <h3 className="mt-5">Links to other sites</h3>
        <p>
          Our Service may contain links to other sites that are not operated by
          us. If you click a third party link, you will be directed to that
          third party's site. We strongly advise you to review the Privacy
          Policy of every site you visit.<br/><br/> We have no control over and assume no
          responsibility for the content, privacy policies or practices of any
          third party sites or services.
        </p>
        <h3 className="mt-5">Children's Privacy</h3>
        <p>
          Our Service does not address anyone under the age of 18 ("Children").<br/><br/>
          We do not knowingly collect personally identifiable information from
          anyone under the age of 18. If you are a parent or guardian and you
          are aware that your Child has provided us with Personal Data, please
          contact us. If we become aware that we have collected Personal Data
          from children without verification of parental consent, we take steps
          to remove that information from our servers.
        </p>
        <h3 className="mt-5">Changes to This Privacy Policy</h3>
        <p>
          We may update our Privacy Policy from time to time. We will notify you
          of any changes by posting the new Privacy Policy on this page.<br/><br/> We will
          let you know via email and/or a prominent notice on our Service, prior
          to the change becoming effective and update the "effective date" at
          the top of this Privacy Policy. <br/>You are advised to review this Privacy
          Policy periodically for any changes. Changes to this Privacy Policy
          are effective when they are posted on this page.
        </p>
        <h3 className="mt-5">Contact Us</h3>
        <p>
          If you have any questions about this Privacy Policy, please contact
          us:<br/><br/> By email: aisupport@inaipi.ai <br/>
          By visiting this page on our
          website: <a href="https://inaipi.ai/#/contact" className="text-blue-500" target="_blank" rel="noopener noreferrer">https://inaipi.ai/#/contact</a>  <br/>
          By
          phone number: +919611101451
          
        </p>
      </div>
      <Footer />
    </div>
  );
}

export default Privacy;
